import { FC } from 'react';

import TypographyWrapper, { ExtendedTypographyProps } from '../../wrappers/TypographyWrapper';

export type FontWeightType = 'normal' | 100 | 200 | 300 | 400 | 500 | 550 | 600 | 700 | 800 | 900;

export interface IAtomTypographyProps extends ExtendedTypographyProps {
  fontWeight?: FontWeightType;
}

const AtomTypography: FC<IAtomTypographyProps> = ({ fontWeight, children, ...props }) => (
  <TypographyWrapper fontWeight={fontWeight} {...props}>
    {children}
  </TypographyWrapper>
);

AtomTypography.displayName = 'AtomTypography';

export default AtomTypography;
